// extracted by mini-css-extract-plugin
export default {"faqsContainer":"Info_faqsContainer__wDlL0","titleWrapper":"Info_titleWrapper__beIm-","container":"Info_container__Qvmuu"};